<template>
  <div class="filterDiv">
    <div class="filterForm" style="padding-bottom:0px">
      <div class="row">
        <div class="col-12">
          <div class="d-flex" style="justify-content: space-between;">
            <div class="portfolioFiterLabel">Cost</div>
            <div style="margin-top:-4px">
              <span class="portfolioRangeValues">{{costValueString}}</span>
              <span class="portfolioRangeClear" @click="clearFilter('cost')">Clear</span>
            </div>
          </div>
          <ejs-slider
            id="costSlider"
            :min="value.cost.lowest"
            :max="value.cost.highest"
            cssClass="portfolioSlider"
            :value="costValue"
            :step="costStep"
            :type="type"
            :change="costTooltipChange"
            v-if="showSlider"
          ></ejs-slider>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="d-flex" style="justify-content: space-between;">
            <div class="portfolioFiterLabel">Multiple</div>
            <div style="margin-top:-4px">
              <span class="portfolioRangeValues">{{multipleValueString}}</span>
              <span class="portfolioRangeClear" @click="clearFilter('multiple')">Clear</span>
            </div>
          </div>
          <ejs-slider
            id="multipleSlider"
            :min="value.multiple.lowest"
            :value="multipleValue"
            :type="type"
            cssClass="portfolioSlider"
            :change="multipleTooltipChange"
            v-if="showSlider"
            :step="multipleStep"
            :max="value.multiple.highest"
          ></ejs-slider>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="d-flex" style="justify-content: space-between;">
            <div class="portfolioFiterLabel">Ownership</div>
            <div style="margin-top:-4px">
              <span class="portfolioRangeValues">{{ownerValueString}}</span>
              <span class="portfolioRangeClear" @click="clearFilter('ownership')">Clear</span>
            </div>
          </div>
          <ejs-slider
            id="ownerSlider"
            :min="value.ownership.lowest"
            :value="ownershipValue"
            :type="type"
            :step="ownerStep"
            cssClass="portfolioSlider"
            v-if="showSlider"
            :change="ownerTooltipChange"
            :max="value.ownership.highest"
          ></ejs-slider>
        </div>
      </div>
      <div class="row" style="margin-bottom:15px">
        <div class="col-12">
          <div class="d-flex" style="justify-content: space-between;margin-bottom:5px">
            <div class="portfolioFiterLabel">Status</div>
            <div style="margin-top:-4px">
              <span class="portfolioRangeClear mr-2" @click="selectAll('status')">Select all</span>
              <span class="portfolioRangeClear" @click="clearFilter('status')">Clear</span>
            </div>
          </div>
          <multiselect
            v-model="statusValues"
            :options="availableStatus"
            :multiple="true"
            :custom-label="customLabel"
            placeholder="Status"
            @input="checkAllValues('status')"
            class="filtersMultiselectDropdown"
          ></multiselect>
        </div>
      </div>
      <div class="row" style="margin-bottom:15px">
        <div class="col-12">
          <div class="d-flex" style="justify-content: space-between;margin-bottom:5px">
            <div class="portfolioFiterLabel">Sector</div>
            <div style="margin-top:-4px">
              <span class="portfolioRangeClear mr-2" @click="selectAll('sector')">Select all</span>
              <span class="portfolioRangeClear" @click="clearFilter('sector')">Clear</span>
            </div>
          </div>
          <multiselect
            v-model="sectorValues"
            :options="availableSectors"
            :multiple="true"
            :custom-label="customLabel"
            placeholder="Sector"
            @input="checkAllValues('sector')"
            class="filtersMultiselectDropdown"
          ></multiselect>
        </div>
      </div>
      <div style="margin-bottom:15px">
        <div class="portfolioFiterLabel">Initial Investment Date Range</div>
        <div class="row">
          <div class="col-6">
            <input
              type="date"
              :value="fromDate && moment(fromDate).format('YYYY-MM-DD')"
              @input="fromDate = moment($event.target.valueAsDate)"
              @change="toDate=''"
              class="todo-form-date todo-form form-control"
            />
          </div>
          <div class="col-6">
            <input
              :min="fromDate && moment(fromDate).format('YYYY-MM-DD')"
              type="date"
              :value="toDate && moment(toDate).format('YYYY-MM-DD')"
              @input="toDate = moment($event.target.valueAsDate)"
              class="todo-form-date todo-form form-control"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="filterFormBtns d-flex">
      <button class="newTask" style="border:0px;cursor:pointer" @click="clearAll">Clear all</button>
      <button class="newTask" style="border:0px;cursor:pointer" @click="applyFilter">Apply</button>
    </div>
  </div>
</template>
<script>
import VueSlider from "vue-slider-component";
import { mapGetters } from "vuex";
import moment from "moment";
import {
  formatCurrency,
  vals,
  formatNumber,
  formatNumberWithComma,
} from "./../../../util";
import Multiselect from "vue-multiselect";
export default {
  computed: {
    ...mapGetters("user", ["currency"]),
    ...mapGetters("portfolio", ["portfolioData", "hasData"]),
    moment() {
      return moment;
    },
    availableSectors() {
      let sectors = this.portfolioData.map((item) => item.sector);
      sectors = [...new Set(sectors)];
      sectors.sort((a, b) => a.localeCompare(b));
      return sectors.filter((opt) => this.sectorValues.indexOf(opt) === -1);
    },
    availableStatus() {
      return this.vals.STATUS_DEFINES.filter(
        (opt) => this.statusValues.indexOf(opt) === -1
      );
    },
  },
  components: {
    VueSlider,
    Multiselect,
  },
  props: {
    value: {
      cost: Object,
      ownership: Object,
      multiple: Object,
    },
  },
  data() {
    return {
      vals,
      costTooltip: {
        placement: "Before",
        isVisible: true,
        format: "C2",
        showOn: "Hover",
      },
      ownerTooltip: {
        placement: "Before",
        isVisible: true,
        format: "P2",
        showOn: "Hover",
      },
      tooltip: {
        placement: "Before",
        isVisible: true,
      },
      mutlipleTooltip: {
        placement: "Before",
        isVisible: true,
        format: "N",
        showOn: "Hover",
      },
      costStep: 3000,
      ownerStep: 0.1,
      multipleStep: 0.1,
      type: "Range",
      costValue: [0, 0],
      ownershipValue: [0, 0],
      multipleValue: [0, 0],
      statusValues: [],
      sectorValues: [],
      showSlider: false,
      costValueString: "",
      ownerValueString: "",
      multipleValueString: "",
      toDate: "",
      fromDate: "",
    };
  },
  methods: {
    formatCurrency: formatCurrency,
    checkAllValues(data) {
      switch (data) {
        case "sector":
          let sectorIndex = this.sectorValues.findIndex(
            (item) => item == "all"
          );
          if (sectorIndex > -1) this.sectorValues.splice(sectorIndex, 1);
          break;
        case "status":
          let statusIndex = this.statusValues.findIndex(
            (item) => item == "all"
          );
          if (statusIndex > -1) this.statusValues.splice(statusIndex, 1);
          break;
      }
    },
    selectAll(type) {
      switch (type) {
        case "sector":
          this.sectorValues = ["all"];
          break;
        case "status":
          this.statusValues = ["all"];
          break;
      }
    },
    clearFilter(type) {
      switch (type) {
        case "cost":
          this.costValue = [this.value.cost.lowest, this.value.cost.highest];
          this.costValueString = `$${formatNumberWithComma(
            this.value.cost.lowest
          )} - $${formatNumberWithComma(this.value.cost.highest)}`;
          break;
        case "multiple":
          this.multipleValue = [
            this.value.multiple.lowest,
            this.value.multiple.highest,
          ];
          this.multipleValueString = `${this.value.multiple.lowest} - ${this.value.multiple.highest}`;
          break;
        case "ownership":
          this.ownershipValue = [
            this.value.ownership.lowest,
            this.value.ownership.highest,
          ];
          this.ownerValueString = `${this.value.ownership.lowest}% - ${this.value.ownership.highest}%`;
          break;
        case "sector":
          this.sectorValues = [];
          break;
        case "status":
          this.statusValues = [];
          break;
      }
    },
    clearAll() {
      //this.$parent.tabulator.clearFilter(true);
      if (
        this.$parent.customFilterArray &&
        this.$parent.customFilterArray.length
      ) {
        this.$parent.tabulator.clearFilter(true);
      }
      this.$parent.filterJson = {};
      this.fromDate = this.toDate = "";
      this.$parent.isFilterApplied = false;
      this.$parent.customFilterArray = [];
      this.clearFilter("cost");
      this.clearFilter("multiple");
      this.clearFilter("ownership");
      this.clearFilter("sector");
      this.clearFilter("status");
      this.$parent.showFilter = false;
      if (this.$parent.searchQuery && this.$parent.searchQuery.length > 0) {
        this.$parent.tabulator.setFilter([this.$parent.searchFilter]);
      }
    },
    applyFilter() {
      const self = this;
      const filterJson = [];
      if (this.costValue && this.costValue.length == 2) {
        filterJson.push(
          {
            field: "cost",
            type: ">=",
            value: this.costValue[0],
          },
          {
            field: "cost",
            type: "<=",
            value: this.costValue[1],
          }
        );
        this.$parent.filterJson.cost = this.costValue;
      }
      if (this.ownershipValue && this.ownershipValue.length >= 2) {
        filterJson.push(
          {
            field: "ownership",
            type: ">=",
            value: this.ownershipValue[0],
          },
          {
            field: "ownership",
            type: "<=",
            value: this.ownershipValue[1],
          }
        );
        this.$parent.filterJson.ownership = this.ownershipValue;
      }
      if (this.multipleValue && this.multipleValue.length >= 2) {
        filterJson.push(
          {
            field: "multiple",
            type: ">=",
            value: this.multipleValue[0],
          },
          {
            field: "multiple",
            type: "<=",
            value: this.multipleValue[1],
          }
        );
        this.$parent.filterJson.multiple = this.multipleValue;
      }
      if (this.statusValues && this.statusValues.length > 0) {
        if (this.statusValues[0] != "all")
          filterJson.push({
            field: "status",
            type: "in",
            value: this.statusValues,
          });
        this.$parent.filterJson.status = this.statusValues;
      } else this.$parent.filterJson.status = [];
      if (this.sectorValues && this.sectorValues.length > 0) {
        if (this.sectorValues[0] != "all")
          filterJson.push({
            field: "sector",
            type: "in",
            value: this.sectorValues,
          });
        this.$parent.filterJson.sector = this.sectorValues;
      } else this.$parent.filterJson.sector = [];
      if (this.fromDate && this.toDate) {
        filterJson.push(
          {
            field: "initial_investment",
            type: ">=",
            value: moment(this.fromDate).format("MM/DD/YYYY"),
          },
          {
            field: "initial_investment",
            type: "<=",
            value: moment(this.toDate).format("MM/DD/YYYY"),
          }
        );
        this.$parent.filterJson.date = {
          fromDate: this.fromDate,
          toDate: this.toDate,
        };
      } else {
        this.$parent.filterJson.date = {};
      }
      if (filterJson.length > 0) this.$parent.customFilterArray = filterJson;
      else {
        filterJson = [
          {
            field: "",
            type: "like",
            value: "",
          },
        ];
      }
      if (this.$parent.searchQuery && this.$parent.searchQuery.length > 0) {
        let tabulatorFilter = [[self.$parent.searchFilter], ...filterJson];
        self.$parent.tabulator.setFilter(tabulatorFilter);
      } else {
        this.$parent.tabulator.setFilter(filterJson);
      }
      this.$parent.isFilterApplied = true;
      this.$parent.showFilter = false;
    },
    customLabel(option) {
      return `${option}`;
    },
    setDefaultRanges() {
      if (this.value.cost && this.value.cost.step)
        this.costStep = this.value.cost.step;
      if (this.$parent.filterJson && this.$parent.filterJson.cost) {
        this.costValue = this.$parent.filterJson.cost;
        this.costValueString = `$${formatNumberWithComma(
          this.costValue[0]
        )} - $${formatNumberWithComma(Math.floor(this.costValue[1]))}`;
      } else {
        this.costValue = [this.value.cost.lowest, this.value.cost.highest];
        this.costValueString = `$${formatNumberWithComma(
          this.value.cost.lowest
        )} - $${formatNumberWithComma(Math.floor(this.value.cost.highest))}`;
      }

      if (this.$parent.filterJson && this.$parent.filterJson.multiple) {
        this.ownershipValue = this.$parent.filterJson.ownership;
        this.ownerValueString = `${this.ownershipValue[0]}% - ${this.ownershipValue[1]}%`;
      } else {
        this.ownershipValue = [
          this.value.ownership.lowest,
          Math.floor(this.value.ownership.highest),
        ];
        this.ownerValueString = `${this.value.ownership.lowest}% - ${this.value.ownership.highest}%`;
      }

      if (this.$parent.filterJson && this.$parent.filterJson.multiple) {
        this.multipleValue = this.$parent.filterJson.multiple;
        this.multipleValueString = `${this.multipleValue[0]} - ${this.multipleValue[1]}`;
      } else {
        this.multipleValue = [
          this.value.multiple.lowest,
          Math.floor(this.value.multiple.highest),
        ];
        this.multipleValueString = `${this.value.multiple.lowest} - ${this.value.multiple.highest}`;
      }

      if (this.$parent.filterJson && this.$parent.filterJson.status) {
        this.statusValues = this.$parent.filterJson.status;
      }
      if (this.$parent.filterJson && this.$parent.filterJson.sector) {
        this.sectorValues = this.$parent.filterJson.sector;
      }
      if (
        this.$parent.filterJson &&
        this.$parent.filterJson.date &&
        this.$parent.filterJson.date.fromDate &&
        this.$parent.filterJson.date.toDate
      ) {
        this.fromDate = this.$parent.filterJson.date.fromDate;
        this.toDate = this.$parent.filterJson.date.toDate;
      }
      this.showSlider = true;
    },
    costTooltipChange(args) {
      let min, max;
      if (args.value && args.value.length >= 2) {
        min = args.value[0];
        max = args.value[1];
      }
      if (String(min) && String(max)) {
        this.costValue = [min, max];
        this.costValueString = `$${formatNumberWithComma(
          min
        )} - $${formatNumberWithComma(max)}`;
      }
    },
    multipleTooltipChange(args) {
      let min, max;
      if (args.value && args.value.length >= 2) {
        min = args.value[0];
        max = args.value[1];
      }
      if (String(min) && String(max)) {
        this.multipleValue = [min, max];
        this.multipleValueString = `${min} - ${max}`;
      }
    },
    ownerTooltipChange(args) {
      let min, max;
      if (args.value && args.value.length >= 2) {
        min = args.value[0];
        max = args.value[1];
      }
      if (String(min) && String(max)) {
        this.ownershipValue = [min, max];
        this.ownerValueString = `${min}% - ${max}%`;
      }
    },
  },
  mounted() {
    this.setDefaultRanges();
  },
};
</script>
<style>
.portfolioSlider .e-slider-track {
  height: 4px !important;
}

.portfolioSlider .e-drag-horizontal {
  height: 4px !important;
  border-radius: 4px !important;
  background-color: #5445f3 !important;
}
.portfolioSlider .e-handle {
  width: 24px !important;
  height: 24px !important;
  background: #ffffff 0% 0% no-repeat padding-box !important;
  box-shadow: 0px 0px 6px #5344f05f !important;
  border: 2px solid #5445f3 !important;
  border-radius: 50%;
  margin-top: -5px !important;
}

.portfolioRangeClear {
  font-size: 10px;
  color: #5445f3;
  opacity: 1;
  cursor: pointer !important;
}

.portfolioRangeValues {
  font-size: 12px;
  letter-spacing: 0px;
  color: #00000098;
  opacity: 1;
  margin-right: 4px;
}
</style>